if ( typeof EnrollmentInquiry !== 'function' ) {
  class EnrollmentInquiry extends HTMLElement {
    constructor() {
      super();

      this.states = this.querySelectorAll('[data-js-enrollment-inquiry-modal-state]');
      
      this.form = this.querySelector('[data-js-enrollment-inquiry-form]');
      this.submit = this.querySelector('[data-js-enrollment-inquiry-submit]');
      this.error = this.querySelector('[data-js-enrollment-inquiry-error]');

      this.requiredInputs = ['_inquiry_first_name', '_inquiry_last_name', '_inquiry_email'];

      this.init();
    }

    init() {
      if (!this.form || !this.submit) return;

      this.form.addEventListener('input', this.configureSubmitState.bind(this));
      this.form.addEventListener('change', this.configureSubmitState.bind(this));
      this.submit.addEventListener('click', this.onSubmit.bind(this));

      this.configureSubmitState();
    }

    configureSubmitState() {
      if (!this.submit) return;

      const isFormValid = this.validateForm();
      if (isFormValid) {
        this.submit.classList.remove('disabled');
        this.submit.removeAttribute('disabled');
      } else {
        this.submit.classList.add('disabled');
        this.submit.setAttribute('disabled', 'disabled');
      }
    }

    validateForm() {
      if (!this.form) return false;

      const isRequiredInputsFilled = this.requiredInputs.every((name) => {
        const input = this.form.querySelector(`[name="${name}"]`);
        return input && input.value.trim() !== '';
      });

      const emailInput = this.form.querySelector('[name="_inquiry_email"]');
      const isEmailValid = emailInput ? emailInput.checkValidity() : false;

      return isRequiredInputsFilled && isEmailValid;
    }

    buildPayload() {
      const formData = new FormData(this.form)
      const entries = Object.fromEntries(formData);

      const answers = [];
      const surveyGroups = this.form.querySelectorAll('[data-js-enrollment-inquiry-survey-group]');
      surveyGroups.forEach((group) => {
        const checked = group.querySelector('input:checked');
        if (checked) {
          const questionElem = group.querySelector('[data-js-enrollment-inquiry-survey-question]');
          const question = questionElem?.textContent.trim() ?? '';
          answers.push({ question, answer: checked.value });
        }
      });

      return {
        leadType: 'stylist',
        firstName: entries._inquiry_first_name || '',
        lastName: entries._inquiry_last_name || '',
        email: entries._inquiry_email || '',
        phone: entries._inquiry_phone || '',
        answers
      };
    }

    async onSubmit() {
      if (this.submit.disabled) return;

      const isFormValid = this.validateForm();
      if (!isFormValid) return;

      this.submit.classList.add('loading');
      this.submit.setAttribute('disabled', 'disabled');
      if (this.error) this.error.classList.add('hide');

      const payload = this.buildPayload();
      const result = await window.backend.submitEnrollmentInquiry(payload);

      if (!result) {
        this.submit.classList.remove('loading');
        this.submit.removeAttribute('disabled');
        if (this.error) this.error.classList.remove('hide');
        return;
      }

      this.submit.classList.remove('loading');
      this.submit.classList.add('has-success');
      setTimeout(() => {
        this.showState('2');
      }, 1500);
    }

    showState(targetIndex) {
      this.states.forEach((state) => { state.classList.add('hide'); });
      const targetState = this.querySelector(`[data-js-enrollment-inquiry-modal-state="${targetIndex}"]`);
      if (targetState) { targetState.classList.remove('hide'); }
    }
  }

  if ( typeof customElements.get('enrollment-inquiry') == 'undefined' ) {
    customElements.define('enrollment-inquiry', EnrollmentInquiry);
  }
}
